<mat-card [class.configured]="configureSelected">
    <mat-card-content>
        <div class="content">
            <!-- title of metric with info icon       -->
            <div class="metric-header">
                <div>
                    <span>{{ displayText() }}</span>

                    <vulcan-icon
                        [matTooltip]="popoverText()"
                        matTooltipShowDelay="250"
                        matTooltipPosition="above"
                        icon="info"
                        weight="bold">
                    </vulcan-icon>
                </div>
            </div>

            <!--      Value displayed-->
            <div class="metric-value">
                @if(loading()) {
                <span>Loading.. </span>
                } @else if (metricData()) {
                <span>{{ metricData().count | number }}</span>
                @if (!isMax()) {
                <div class="trending-indicator trend-{{ metricData().trendDirection.valueOf() }}">
                    @if (metricData().trendDirection.valueOf() === 'increasing') {
                    <fa-icon icon="arrow-trend-up"></fa-icon>
                    <span>{{ metricData().difference | number }}</span>
                    } @else if (metricData().trendDirection.valueOf() === 'decreasing') {
                    <fa-icon icon="arrow-trend-down"></fa-icon>
                    <span>{{ metricData().difference | number }}</span>
                    } @else {
                    <fa-icon icon="arrow-right"></fa-icon>
                    }
                </div>
                } } @else {
                <span> Not Available</span>
                }
            </div>

            @if (isMax() && metricData() && !loading()) {
            <div class="measurement-date">
                <span>Observed at: {{ metricData().timestamp | momentDate : undefined : true }}</span>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>
